import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      if (!localStorage.getItem("ozono_install_dismissed")) setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem("ozono_install_dismissed", "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="install-prompt-banner"
      className="fixed z-50 top-[72px] inset-x-3 sm:top-[108px] lg:top-auto lg:inset-x-auto lg:right-6 lg:bottom-24 bg-white border border-slate-200 shadow-xl rounded-2xl p-3 sm:p-4 flex items-center gap-3 lg:max-w-xs fade-up"
    >
      <img src="/icons/icon-192.png" alt="Lavandería Ozono" className="h-11 w-11 rounded-xl" />
      <div className="flex-1 min-w-0">
        <p className="font-heading font-semibold text-sm text-slate-900">Lavandería Ozono</p>
        <p className="text-xs text-slate-500">Instala la app en tu móvil: acceso rápido sin navegador</p>
      </div>
      <Button size="sm" onClick={install} data-testid="install-app-btn"
        className="bg-cyan-500 hover:bg-cyan-600 rounded-full px-3 h-9">
        <Download className="h-4 w-4" /><span className="lg:hidden">Instalar</span>
      </Button>
      <button onClick={dismiss} data-testid="install-dismiss-btn" aria-label="Cerrar"
        className="text-slate-400 hover:text-slate-600 p-1">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default InstallPrompt;
